import React, { useState, useRef, useEffect } from "react";
import { api, apiError } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Button } from "@/components/ui/button";
import { Navigation, MapPin } from "lucide-react";
import { toast } from "sonner";

export const ShareLocationButton = ({ orderId }) => {
  const { t } = useLang();
  const [sharing, setSharing] = useState(false);
  const watchRef = useRef();

  const stop = () => {
    if (watchRef.current != null) navigator.geolocation.clearWatch(watchRef.current);
    watchRef.current = null;
    setSharing(false);
  };

  useEffect(() => () => stop(), []); // eslint-disable-line

  const toggle = () => {
    if (sharing) { stop(); return; }
    if (!navigator.geolocation) { toast.error("Géolocalisation non supportée"); return; }
    watchRef.current = navigator.geolocation.watchPosition(
      async (p) => {
        try { await api.post(`/delivery/${orderId}/location`, { lat: p.coords.latitude, lng: p.coords.longitude }); }
        catch (e) { /* silent */ }
      },
      (err) => { toast.error(apiError(err, "Position refusée")); stop(); },
      { enableHighAccuracy: true, maximumAge: 5000, timeout: 15000 }
    );
    setSharing(true);
    toast.success(t("sharing_on"));
  };

  return (
    <Button size="sm" variant={sharing ? "default" : "outline"} onClick={toggle}
      className={sharing ? "bg-mango-600 hover:bg-mango-700 animate-pulse" : ""} data-testid={`share-location-${orderId}`}>
      {sharing ? <Navigation className="w-3.5 h-3.5 mr-1" /> : <MapPin className="w-3.5 h-3.5 mr-1" />}
      {sharing ? t("sharing_stop") : t("share_location")}
    </Button>
  );
};
